import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/ContactUs";
import Rewire from "./pages/Rewire";
function App() {
  const helmetContext = {};
  return (
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Rewire" element={<Rewire />} />
        </Routes>
      </BrowserRouter> 
  );
}

export default App;
